import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScanBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 49,
	height: 55,
	viewBox: "0 0 49 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "scan-box",
		d: "M23.275 55V28.4483L0 15.0144V41.6451L23.275 55ZM25.4917 55L48.7667 41.6451V15.0144L25.4917 28.4483V55ZM36.8125 19.3606L47.5 13.2759L24.3833 0L13.9333 6.00575L36.8125 19.3606ZM24.3833 26.5517L34.5958 20.625L11.5583 7.34914L1.34583 13.1968L24.3833 26.5517Z",
		fill: "#4E5B61"
	})
});
export default SvgScanBox;
